import { Method, AxiosRequestConfig } from "axios";



export const buildGetCuurencyRequestConfig = (
    UrlParts: (string | number | boolean)[],
    requestMethod: Method = "GET",
    data: any = null,
  ): AxiosRequestConfig<any> => {
    const mergedUrl = UrlParts.join('')
    const request = {
      url: mergedUrl,
      method: requestMethod,
    }
    return request
  }


export const getCurrencies = (): AxiosRequestConfig => (
    buildGetCuurencyRequestConfig(["http://data.fixer.io/api/latest?access_key=567177c8b5e9b82daf65eba4859d7e68&symbols=GBP,EUR,USD,SEK,CAD,AUD,CNY"])
    
  );
  